module.exports = __webpack_public_path__ + "media/metronic/_theme/media/logos/logo-10-2c33d4a845dd5f2537703dff7ca5e4a4.png";